import React, { useEffect, useState, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// 变量名
import { publicPath } from '@src/constants';
// 数据源
import { ListStore } from '../../store';
// 组件
import UserFun from './UserFun';
import { clipTextH5 } from '@ifeng-fe/ui_clip_text';
// 素材
import defaultAvatar from '@src/mobile/details/layout/assets/defaultAvatar.png';
import iconV from '@src/mobile/details/layout/assets/iconV.png';
// 跳转
import { groundsDispatch } from '@src/utils/app';
// 拉端
import { callApp, getSchemeLink } from '@ifeng-fe/callapp';
import { setAppQuery, setAppQueryNoImmersion, setQuery } from '@src/utils/url';
// 微信开放标志
import { WxLaunchApp } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchApp/dynamic';
// 新版Grounds
import { Grounds } from '@ifeng-fe/client_grounds';

const Details = ({ content }) => {
    // 列表数据源
    const useListStore = ListStore.useContainer();
    const { listStates, changeListStates } = useListStore;
    const { account, currentVideo, dramaSeries, statusBarHeight, videoAndStatusBarHeight, videoHeight } = listStates;

    const [isShowAllSummary, setIsShowAllSummary] = useState(false); // 简介的展开收起状态
    const [isSummaryOver, setIsSummaryOver] = useState(false);

    const summaryRef = useRef();

    // 微信开放标记
    const schemeLink = getSchemeLink({
        docType: 'web',
        noKindFrom: 1,
        pid: location.href,
        kind: 'inter_fxytz01',
    });

    // 拉端
    const callClientHandle = (isSendCount = true, isJumpQQlink = false, isCallApp = true) => {
        if (!window.grounds && isCallApp) {
            return callApp({
                docType: 'web',
                pid: setQuery(window.location.href),
                kind: 'inter_da01',
                noKindFrom: 1,
                download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1512057577113',
                downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=8927',
            });
        }
    };

    // 标签
    const handleClass = name => {
        if (window.grounds) {
            const nameSplit = name.split('-')[0];

            const option = {
                type: 'web',
                url: setAppQueryNoImmersion(`${publicPath}/allContent?label=${nameSplit}`),
            };

            Grounds.dispatch(option);
            // window.grounds.dispatch('web', setAppQueryNoImmersion(url));
        }
        // 端外点击拉端
        callClientHandle();
    };

    // 用户主页
    const handleUser = () => {
        // console.log('跳转用户主页');
        if (window.grounds) {
            const { eAccountId } = account;

            groundsDispatch({ to: String(eAccountId), type: 'vampire' });
        }
        // 端外点击拉端
        callClientHandle();
    };

    useEffect(
        () => {
            setIsShowAllSummary(false);
            setTimeout(judgeIsOver);
        },
        [currentVideo],
    );
    const judgeIsOver = () => {
        const node = summaryRef.current;

        if (node) {
            setIsSummaryOver(node.scrollHeight > node.clientHeight);
        }
    };
    const toggleIsShowAllSummary = () => setIsShowAllSummary(!isShowAllSummary);

    return (
        <div className={styles.wrap}>
            <div className={styles.content}>
                <div className={styles.introductMain}>
                    <div className={styles.introductMainTitleWrap}>
                        <div className={styles.introductMainTitle}>{dramaSeries?.title ? dramaSeries.title : ''}</div>
                        <div className={styles.introductMainTypeWrap}>
                            {dramaSeries?.content?.tags
                                ? dramaSeries.content.tags.split(',').map((item, index) => {
                                      return (
                                          <div
                                              className={styles.introductMainType}
                                              key={index}
                                              onClick={() => handleClass(item)}>
                                              {item}
                                          </div>
                                      );
                                  })
                                : null}
                        </div>
                    </div>

                    <div className={styles.introductMainUserWrap}>
                        <div className={styles.introductMainUser}>
                            <div className={styles.introductMainUserIcon} onClick={handleUser}>
                                <img className={styles.introductMainUserAvatar} src={account?.logo} />
                                <img className={styles.introductMainUserIconV} src={iconV} />
                            </div>

                            <div className={styles.introductMainUserName} onClick={handleUser}>
                                {account?.weMediaName}
                            </div>
                        </div>
                        <div
                            ref={summaryRef}
                            className={`${styles.introductMainText} ${isShowAllSummary ? '' : styles.hide}`}>
                            {currentVideo?.summary}

                            {isSummaryOver &&
                                !isShowAllSummary && (
                                    <span className={styles.moreBtn} onClick={toggleIsShowAllSummary}>
                                        更多
                                    </span>
                                )}
                        </div>
                    </div>
                </div>
            </div>
            {/* 用户功能 */}
            {window.grounds ? <UserFun content={content} /> : null}
            {/* 微信开放标记 */}
            {window.grounds ? (
                <WxLaunchApp
                    launchType="app"
                    launchAppClick={() => {
                        callClientHandle(true, false, false);
                    }}
                    schemeLink={schemeLink}
                    launchAppFail={() => {
                        callClientHandle(false, true, true);
                    }}
                />
            ) : null}
        </div>
    );
};

Details.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Details);
